import { Observable } from 'rxjs';
import { City, Country, DataSourceFilter, DataSourceResponse, Region } from '../../models';
export abstract class AddressApi {

  abstract getCountries(filter: DataSourceFilter): Observable<DataSourceResponse<Country>>;
  abstract getRegions(filter?: DataSourceFilter): Observable<DataSourceResponse<Region>>;
  abstract getCities(filter: DataSourceFilter): Observable<DataSourceResponse<City>>;
  /** Country */
  abstract createCountry(country: Country): Observable<any>;
  abstract editCountry(id: string, country: Country): Observable<any>;
  abstract deleteCountry(id: string): Observable<any>;
  abstract deleteCountryRange(ids: string[]): Observable<any>;
  /** Region */
  abstract createRegion(model: Region): Observable<any>;
  abstract editRegion(id: string, model: Region): Observable<any>;
  abstract deleteRegion(id: string): Observable<any>;
  abstract deleteRegionRange(ids: string[]): Observable<any>;
  /** City */
  abstract createCity(model: City): Observable<any>;
  abstract editCity(id: string, model: City): Observable<any>;
  abstract deleteCity(id: string): Observable<any>;
  abstract deleteCityRange(ids: string[]): Observable<any>;
}
